class FadeCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.slides = [];
    }
  
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.featured-products__carousel-item'));
      this.prevButton = this.querySelector('.fade-button--prev');
      this.nextButton = this.querySelector('.fade-button--next');
  
      if (!this.slides.length) return;
  
      this.showSlide(this.currentIndex);
      this.setHeight();
  
      this.prevButton?.addEventListener('click', () => this.prevSlide());
      this.nextButton?.addEventListener('click', () => this.nextSlide());
  
      window.addEventListener('resize', () => this.setHeight());
    }
  
    showSlide(index) {
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
    }
  
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.showSlide(this.currentIndex);
      this.setHeight();
    }
  
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.showSlide(this.currentIndex);
      this.setHeight();
    }
  
    setHeight() {
      const activeSlide = this.slides[this.currentIndex];
      this.style.height = `${activeSlide.offsetHeight}px`;
    }
}
  
customElements.define('fade-carousel', FadeCarousel);